import { Icon } from "@src/components/ui-kit/Icon";
import {
  PopoverProjectActions,
  type PopoverProjectActionsProps,
} from "@src/components/widgets/PopoverProjectActions";
import { Can } from "@src/utils/components/permissions";
import { QuickFilter, useStore } from "../../Store";

interface ActionsProps {
  project: PopoverProjectActionsProps["project"];
}

export const Actions = ({ project }: ActionsProps) => {
  const store = useStore();

  return (
    <Can
      do={[
        "project_archive_all",
        "project_archive_own",
        "project_archive_team",
        "project_delete_all",
        "project_delete_own",
        "project_delete_team",
        "project_duplicate_all",
        "project_duplicate_own",
        "project_duplicate_team",
        "project_finish_all",
        "project_finish_own",
        "project_finish_team",
        "project_update_all",
        "project_update_own",
        "project_update_team",
        "project_pin_all",
        "project_pin_own",
        "project_pin_team",
        "requestForInvoicing_create_all",
        "requestForInvoicing_create_own",
        "requestForInvoicing_create_team",
      ]}
    >
      <PopoverProjectActions
        project={project}
        hideActions={
          store.quickFilter.value[0] === QuickFilter.Pinned
            ? ["pin-unpin"]
            : undefined
        }
        activator={() => <Icon name="dots-horizontal" color="#02929d" />}
        onAction={store.fetchTableData}
      />
    </Can>
  );
};
